// extracted by mini-css-extract-plugin
export default {"root":"_2rRj-","flames":"_1U94R","flame":"_2n9Fg"};